import React from 'react';
import { styled, keyframes } from '@mui/material/styles';
import { COLORS } from '../theme/theme-options';

const strokeCircle = keyframes`
  0% {
    stroke-dashoffset: 166;
  }
  100% {
    stroke-dashoffset: 0;
  }
`;

const strokeCheck = keyframes`
  0% {
    stroke-dashoffset: 48;
  }
  100% {
    stroke-dashoffset: 0;
  }
`;

const scale = keyframes`
  0%, 100% {
    transform: none;
  }

  50% {
    transform: scale3d(1.1, 1.1, 1);
  }
`;

const fill = keyframes`
  0% {
    box-shadow: inset 0px 0px 0px 0px ${COLORS.primary[400]};
  }
  100% {
    box-shadow: inset 0px 0px 0px 30px ${COLORS.primary[400]};
  }
`;

const Checkmark = styled('svg')({
  width: 100,
  height: 100,
  borderRadius: '50%',
  display: 'block',
  strokeWidth: 2,
  stroke: COLORS.primary[400],
  strokeMiterlimit: 10,
  boxShadow: `inset 0px 0px 0px 0px ${COLORS.primary[400]}`,
  animation: `${fill} 10s ease-in-out 10s forwards, ${scale} 10s ease-in-out 10s both`,
  position: 'relative',
  top: 5,
  right: 5,
  margin: '0 auto',
});

const CheckmarkCircle = styled('circle')({
  strokeDasharray: 166,
  strokeDashoffset: 166,
  strokeWidth: 2,
  strokeMiterlimit: 10,
  stroke: COLORS.primary[400],
  fill: COLORS.grey[800],
  animation: `${strokeCircle} 0.6s cubic-bezier(0.65, 0, 0.45, 1) forwards`,
});

const CheckmarkPath = styled('path')({
  transformOrigin: '50% 50%',
  strokeDasharray: 48,
  strokeDashoffset: 48,
  stroke: COLORS.primary[400],
  strokeWidth: 2,
  strokeLinecap: 'round',
  fill: 'none',
  animation: `${strokeCheck} 0.3s cubic-bezier(0.65, 0, 0.45, 1) 0.8s forwards`,
});

export const SuccessCheckmark: React.FC = () => {
  return (
    <Checkmark viewBox="0 0 52 52">
      <CheckmarkCircle cx={26} cy={26} r={25} />
      <CheckmarkPath d="M14.1 27.2l7.1 7.2 16.7-16.8" />
    </Checkmark>
  );
};
